import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import RailwayLogo from '../../../../../resources/images/header-icons/railwayLogo.png';
import RailwayLogoKa from '../../../../../resources/images/header-icons/railwayLogoKa.svg';
import { ReactComponent as Account } from '../../../../../resources/images/header-icons/account.svg';
import { ReactComponent as Calendar } from '../../../../../resources/images/header-icons/calendar.svg';
import { ReactComponent as Logout } from '../../../../../resources/images/header-icons/logout.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import LanguageSelector from '../LanguageSelector';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import { useAuth } from '../../../../contexts/userContext/userContext';
import DesktopHeaderInfoContent from './DesktopHeaderInfoContent';

const authorizeButtonClass = 'font-big border-0 bg-transparent px-1 lg:text-2sm xl:text-base text-black hover:text-primary ease-out duration-300 cursor-pointer flex gap-[10px] items-center hover-icon nav-link';

function Header() {
  const { trans, currentLanguage, configInfo } = useTranslation();
  const { setShowAuthModal } = useModal();
  const { user, resetUser, accessToken } = useAuth();

  return (
    <div className="fixed z-50 shadow-xl hidden lg:flex justify-between px-[32px] bg-white h-[120px] items-center container rounded-b-3xl">
      <div className="flex gap-[55px] items-center">
        <Link to={`/${currentLanguage}`}>
          {configInfo?.countryCode === 'GE'
            ? (
              <img
                src={currentLanguage === 'ka' ? RailwayLogoKa : RailwayLogo}
                alt="Georgian Railway Logo"
                width={211}
                height={60}
              />
            )
            : (
              <img
                src="/ticketLogos/logoArm.png"
                alt="Armenia Railway Logo"
                width={211}
                height={60}
              />
            )}
        </Link>
      </div>
      <nav className="flex lg:gap-5 xl:gap-[30px] items-center">

        {user?.name ? (
          <NavLink to="profile" className={`${authorizeButtonClass} capitalize`}>
            <Account className="h-5 w-5" />
            {user?.first_name || user?.name}
          </NavLink>
        )
          : (
            <button type="button" className={authorizeButtonClass} onClick={() => setShowAuthModal(true)}>
              <Account className="h-5 w-5" />
              {trans('authorization')}
            </button>
          )}
        <NavLink to="schedule" className={authorizeButtonClass}>
          <Calendar />
          {trans('schedule')}
        </NavLink>
        <DesktopHeaderInfoContent />
        {accessToken && (
          <button type="button" className={authorizeButtonClass} onClick={resetUser}>
            <Logout className="h-4 w-4" />
          </button>
        )}
        <LanguageSelector />
      </nav>
    </div>
  );
}

export default Header;
